var _LowQualityIndicator;
import { Fragment } from 'react';
import { LowQualityIndicator } from "../../ui";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var OptionButton = function OptionButton(_ref) {
  var changeSection = _ref.changeSection,
    id = _ref.id,
    label = _ref.label,
    value = _ref.value,
    hasLowQuality = _ref.hasLowQuality;
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsxs("button", {
      type: "button",
      className: "bg-transparent focus:outline-none w-full flex items-center font-button text-base-main py-32",
      onClick: function onClick() {
        changeSection(id);
      },
      "aria-label": value ? "".concat(label, " - ").concat(value) : label,
      children: [hasLowQuality && (_LowQualityIndicator || (_LowQualityIndicator = /*#__PURE__*/_jsx(LowQualityIndicator, {
        className: "mr-8"
      }))), label, value && /*#__PURE__*/_jsx("span", {
        className: "font-label text-gray-dark",
        children: " - ".concat(value)
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "w-full bg-gray-light",
      style: {
        height: '1px'
      }
    })]
  });
};
export default OptionButton;